import { useMemo } from 'react';
import { getDailyProverbIndex } from '../utils/dateUtils';

interface Proverb {
  marathi: string;
  literal: string;
  idiomatic: string;
}

export const useDailyProverb = (proverbs: Proverb[]) => {
  const dailyProverb = useMemo(() => {
    if (!proverbs || proverbs.length === 0) {
      return null;
    }

    const index = getDailyProverbIndex(proverbs.length);
    return proverbs[index];
  }, [proverbs]);

  return dailyProverb;
};
